
import Vue from "vue";
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

export default Vue.extend({
  name: "DownloadJson",
  components: { VueJsonPretty },
  data() {
    return {
      loading: false as boolean,
      dialog: false as boolean,
    };
  },
  props: {
    form: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    downloadJSON() {
      this.loading = true;
      const data = JSON.stringify(this.form)
      const blob = new Blob([data], {type: 'text/plain'})
      const e = document.createEvent('MouseEvents'),
          a = document.createElement('a');
      a.download = "form.json";
      a.href = window.URL.createObjectURL(blob);
      a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
      e.initEvent('click', true, false);
      a.dispatchEvent(e);
      this.loading = false;
      this.dialog = false;
    }
  }
});
